import React from "react";
import clsx from "clsx";

interface Props {
  describe: string;
  classNames?: string;
}

/**
 * オプション説明欄
 */
export function ServiceOptionDescribe({ describe, classNames }: Props) {
  return (
    <>
      <span
        className={clsx(
          "text-[#626262] break-word text-sm leading-[21px]",
          classNames,
        )}
      >
        {describe}
      </span>
    </>
  );
}
